import { render, staticRenderFns } from "./task-list.vue?vue&type=template&id=7775e77a&scoped=true"
import script from "./task-list.vue?vue&type=script&lang=js"
export * from "./task-list.vue?vue&type=script&lang=js"
import style0 from "./task-list.vue?vue&type=style&index=0&id=7775e77a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7775e77a",
  null
  
)

export default component.exports